import loadable from '@loadable/component';

// 懒加载组件
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const SupHospitalManagement = loadable(() => import('./supHospitalManagement/SupHospitalManagement'));

export const subRoutes = [
  {
    // 423002 供应商药品查询
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    // M242006 【药品】供应商：供货医院管理
    path: '/SupHospitalManagement',
    component: SupHospitalManagement
  }
];
